import type { SidebarDensity } from "~/uiStateStore";

// ---------------------------------------------------------------------------
// Pure logic (exported for testing)
// ---------------------------------------------------------------------------

/**
 * Determine the default density for a workspace given its row count.
 * ≥4 rows → compact (one-line);  ≤3 rows → comfortable (two-line).
 */
export function resolveDefaultDensity(rowCount: number): SidebarDensity {
  return rowCount >= 4 ? "compact" : "comfortable";
}

export function shouldShowTimestamp(density: SidebarDensity): boolean {
  return density !== "compact";
}
